import React, { Component } from 'react';
import { Modal, Button } from 'antd';
import TableC from '../../../basicElement/TableC';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';

class Log extends Component {
    state = {
        data: [],
        record: {},
        visible: false,
        loading: false,
    }

    show = (record) => {
        this.setState({
            record,
            visible: true,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({
            data: [],
            visible: false,
        });
    }

    loadData = () => {
        const { record: { investigationJdeContractModifyApplyId } } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.contract.queryJdeApplyApprovalHistory,
            data: {
                jdeApplyId: investigationJdeContractModifyApplyId,
                type: 'CONTRACT_MODIFY_LOG'
            },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    data: res.data,
                    loading: false,
                })
            }
        };
        $.sendRequest(options);
    }

    getColumns = () => ([
        {
            title: '操作时间',
            dataIndex: 'approvalDate',
            key: 'approvalDate',
            width: 80,
        }, {
            title: '操作人',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            width: 110,
            render: (text, record) => {
                const { employeeCode } = record;
                return `${text}${employeeCode ? `(${employeeCode})` : ''}`;
            }
        }, {
            title: '操作内容',
            dataIndex: 'approvalContent',
            key: 'approvalContent',
            width: 120,
        }, {
            title: '操作结果',
            dataIndex: 'approvalResult',
            key: 'approvalResult',
            width: 120,
        },  {
            title: '拒绝/不通过原因',
            dataIndex: 'comments',
            key: 'comments',
            width: 170,
        }
    ])

    render() {
        const { visible, loading, record, data } = this.state;
        const { investigationName, applyCode, investigationJdeContractCode } = record;
        return (
            <Modal
                title="操作日志"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                maskClosable={false}
                width={900}
                bodyStyle={{ maxHeight: 600 }}
                footer={<Button onClick={this.hide}>关闭</Button>}
            >
                <div className="cont-cont contract-record" style={{margin: 20}}>
                    <div style={{ marginBottom: 16 }}>
                        申请编号：{applyCode}
                        <span className="ant-divider" />
                        项目简称：{investigationName}
                        <span className="ant-divider" />
                        <br />
                        JDE项目号：{investigationJdeContractCode}
                    </div>
                    <TableC
                        loading={loading}
                        scrollY={400}
                        columns={this.getColumns()}
                        data={data}
                        className="log"
                        rowKey="jdeApplyApprovalHistoryId"
                    />
                </div>
            </Modal>
        );
    }
}

export default Log;



// WEBPACK FOOTER //
// ./src/components/contractManagement/contractInfoChange/components/Log.js